/**
 * Assuming a very specific type of HTML string, extract URL in worst possible way
 */
export default function urlExtractor(html) {
  const parts = html ? html.split('"') : [];
  return parts.length > 1 ? parts[1] : null;
}
